import React from 'react';
export default function Breadcrumbs() { return null; }
